export const photoTypes = [
  {
    label: "Обложка",
    value: "cover",
  },
  {
    label: "Каталог",
    value: "catalog",
  },
];
